import EmailJS from "@emailjs/browser";
import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import ReCAPTCHA from "react-google-recaptcha";
import logo from "../../assets/solar/floatinglogo.svg";
import config from "../../contexts/config";
import "./FloatingChatButton.scss";

import TagManager from "@sooro-io/react-gtm-module";
import { getCookieConsentValue } from "react-cookie-consent";

const FloatingChatButton = forwardRef((props, ref) => {
  EmailJS.init({
    publicKey: "M8bnFBJgRsoMNF3Hf",
    // Do not allow headless browsers
    blockHeadless: true,
    limitRate: {
      // Set the limit rate for the application
      id: "app",
      // Allow 1 request per 10s
      throttle: 10000,
    },
  });
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subscribe, setSubscribe] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [isError, setError] = useState(false);
  const [openedChatAlredy, setOpenedChatAlredy] = useState(false);
  const recaptchaRef = useRef(null);

  useImperativeHandle(ref, () => ({
    openChat: () => {
      setIsChatOpen(true);
      handleOpenedChatAlready(true);
    },
  }));

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
    handleOpenedChatAlready(true);
  };

  const handleOpenedChatAlready = (e) => {
    if (
      e &&
      !openedChatAlredy &&
      getCookieConsentValue("sutiBeleegyezes") === "true"
    ) {
      TagManager.initialize({ gtmId: "GTM-5Q4TKR7T" });
      TagManager.dataLayer({
        dataLayer: {
          event: "view_form",
          form_type: "visszahivas",
        },
      });
    }
    setOpenedChatAlredy(e);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleSubscribeChange = (e) => {
    setSubscribe(e.target.checked);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    recaptchaRef.current.execute();
  };

  const handleRecaptchaChange = (token) => {
    if (!token) {
      setError(true);
      return;
    }
    let feliratkozott = subscribe
      ? "Feliratkozott a hírlevélre."
      : "Nem iratkozott fel a hírlevélre.";
    EmailJS.send("service_x9pofce", "template_261u3o4", {
      name,
      email,
      phone,
      feliratkozott,
    })
      .then(() => {
        if (getCookieConsentValue("sutiBeleegyezes") === "true") {
          TagManager.initialize({ gtmId: "GTM-5Q4TKR7T" });

          TagManager.dataLayer({
            dataLayer: {
              event: "generate_lead",
              form_type: "visszahivas",
              name: name,
              email: email,
              phone: phone,
            },
          });
        }
        fetch(`${config.API_URL_ONRENDER}/minicrm/addUser`, {
          method: "PUT",
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${localStorage.token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            Name: name,
            Email: email,
            Phone: phone,
            Type: "Business",
            recaptchaToken: token,
          }),
        })
          .then((response) => {
            setLoading(false);
            if (!response.ok) {
              setError(true);
              return response.json().then((error) => {
                throw new Error(error.message || "Unknown error");
              });
            }
            setName("");
            setEmail("");
            setPhone("");
            setSubscribe(false);
            setSuccess(true);
            setError(false);

            return response.json();
          })
          .catch((error) => {
            setError(true);
            setLoading(false);
            console.error("Error:", error);
          });
      })
      .catch(() => {
        setSuccess(false);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  let loadingButton;

  if (isLoading) {
    loadingButton = (
      <div className="load-wrapp">
        <div className="load-2">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    );
  } else {
    if (isSuccess) {
      loadingButton = <span>Sikeres beküldés!</span>;
    } else if (isError) {
      loadingButton = <span>Hiba történt!</span>;
    } else {
      loadingButton = <span>Visszahívás</span>;
    }
  }

  let color;

  if (isLoading) {
    color = "black";
  } else {
    if (isSuccess) {
      color = "#008000";
    } else if (isError) {
      color = "#C70039";
    } else {
      color = "black";
    }
  }

  return (
    <div
      className="floating-chat-button"
      id={
        getCookieConsentValue("sutiBeleegyezes") === "true"
          ? "sutiElfogadva"
          : "sutiNemElfogadva"
      }>
      <img src={logo} alt="Lebegő Chat logo" className="floating-chat-logo" />
      <div className={`chat-box ${isChatOpen ? "open" : "close"}`}>
        <h3 style={{ textAlign: "center", marginBottom: "24px" }}>
          Visszahívás kérése
        </h3>
        <p style={{ textAlign: "justify", marginBottom: "24px" }}>
          Töltse ki az alábbi mezőket adataival, és munkanapokon 24 órán belül
          visszahívjuk!
        </p>
        <form onSubmit={handleSubmit} id="emailForm">
          <input
            type="text"
            placeholder="Teljes Név"
            value={name}
            required
            onChange={handleNameChange}
          />
          <input
            type="email"
            placeholder="E-mail cím"
            value={email}
            required
            onChange={handleEmailChange}
          />
          <input
            type="tel"
            placeholder="Telefonszám"
            value={phone}
            required
            onChange={handlePhoneChange}
          />
          <div style={{ marginTop: "18px", marginBottom: "24px" }}>
            {" "}
            <input
              style={{
                height: "18px",
                float: "left",
                width: "auto",
                accentColor: "black",
              }}
              type="checkbox"
              name="subscribe"
              id="subscribe"
              className="hover-cursor"
              placeholder="Feliratkozás"
              value={subscribe}
              onChange={handleSubscribeChange}
            />
            <label
              htmlFor="subscribe"
              style={{ paddingLeft: "12px" }}
              className="hover-cursor">
              {" "}
              Feliratkozom a hírlevelekre.
            </label>
          </div>
          <button
            type="submit"
            style={{ backgroundColor: color }}
            disabled={isLoading}>
            {loadingButton}
          </button>
        </form>
        <button className="close-button" onClick={toggleChat}>
          &times;
        </button>
      </div>
      <ReCAPTCHA
        size="invisible"
        sitekey="6LdvmMEqAAAAANhHg48CnjWGHzSULz69qbkrOvws"
        ref={recaptchaRef}
        onChange={handleRecaptchaChange}
        badge="bottomleft"
        theme="light"
      />
      <div className="circle" onClick={toggleChat}></div>
    </div>
  );
});

export default FloatingChatButton;
